import { PageOptions } from 'editor/src/store/variants/types';

/**
 * Snaps a typed page count onto the closest count the product actually supports:
 * inside [min, max] and on the `step` grid the price/spread structure is built from.
 * Returns `undefined` when the input is not a number, so the caller can keep the
 * previous value instead of guessing one. `keepToGrid` (the host's `enablePageCountOptions`)
 * keeps a max that is off the grid out of reach.
 */
function clampPageCount(value: string, pages: PageOptions, keepToGrid = false): number | undefined {
  const parsed = parseInt(value, 10);
  if (Number.isNaN(parsed)) {
    return undefined;
  }

  const bounded = Math.max(pages.min, Math.min(pages.max, parsed));
  const step = pages.step > 0 ? pages.step : 1;
  const snapped = pages.min + Math.round((bounded - pages.min) / step) * step;

  if (!keepToGrid) {
    return Math.min(pages.max, snapped);
  }
  // A max off the grid is not a page count the product is made in, so stay on the last grid value.
  return snapped > pages.max ? snapped - step : snapped;
}

export default clampPageCount;
